import useAuth from "./useAuth";

const useIsRetailPartner = () => {
  const { user } = useAuth();
  return Boolean(user?.is_retail_partner);
};

export default useIsRetailPartner;
